export default "/static/dashboard/build/app/img/v2/e177fc8dd03df958bf485b691d8d7c23.png";